//users actions
export const GET_USERS = 'GET_USERS';
export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';

export const POPULATE_USERS = 'POPULATE_USERS';
export const POPULATE_USERS_REQUEST = 'POPULATE_USERS_REQUEST';
